import React, { useState, useEffect } from 'react';
import api from '../../api/axiosConfig';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Table, Tabs, Pagination } from 'antd';
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import '../Css/AnaliseComponente.css';
import {
  LineChartOutlined,
  BarChartOutlined,
  AreaChartOutlined,
  BulbOutlined,
  MenuOutlined
} from '@ant-design/icons';

const AnaliseParImparCC = () => {
  const navigate = useNavigate();
  const [repData, setRepData] = useState({});
  const [atrasoData, setAtrasoData] = useState({});
  const [frequeData, setFrequeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeKey, setActiveKey] = useState("1");

  const [currentRepPage, setCurrentRepPage] = useState(1);
  const [currentAtrasoPage, setCurrentAtrasoPage] = useState(1);

  useEffect(() => {
    if (loading) {
      Swal.fire({
        title: 'Carregando...',
        text: 'Estamos processando as informações.',
        icon: 'info',
        showConfirmButton: false,
        willOpen: () => Swal.showLoading()
      });
    }
  }, [loading]);

  useEffect(() => {
    api.get(`${process.env.REACT_APP_API_URL}/estatistica_atraso_rep_linhas_par_cc`)
      .then(response => setRepData(prev => ({ ...prev, estatistica_atraso_rep_par: response.data.data })))
      .catch(() => setRepData(prev => ({ ...prev, estatistica_atraso_rep_par: [] })));

    api.get(`${process.env.REACT_APP_API_URL}/estatistica_atraso_rep_linhas_impar_cc`)
      .then(response => {
        setRepData(prev => ({ ...prev, estatistica_atraso_rep_impar: response.data.data }));
        setLoading(false);
      })
      .catch(() => {
        setRepData(prev => ({ ...prev, estatistica_atraso_rep_impar: [] }));
        setLoading(false);
      });

    api.get(`${process.env.REACT_APP_API_URL}/freque_par_impar_cc`)
      .then(response => setFrequeData(Array.isArray(response.data.data) ? response.data.data : []))
      .catch(() => setFrequeData([]));

    api.get(`${process.env.REACT_APP_API_URL}/estatistica_atraso_par_cc`)
      .then(response => setAtrasoData(prev => ({ ...prev, estatistica_atraso_par: response.data.data })))
      .catch(() => setAtrasoData(prev => ({ ...prev, estatistica_atraso_par: [] })));

    api.get(`${process.env.REACT_APP_API_URL}/estatistica_atraso_impar_cc`)
      .then(response => setAtrasoData(prev => ({ ...prev, estatistica_atraso_impar: response.data.data })))
      .catch(() => setAtrasoData(prev => ({ ...prev, estatistica_atraso_impar: [] })));
  }, []);

  useEffect(() => {
    if (!loading) {
      setTimeout(() => Swal.close(), 1500);
    }
  }, [loading]);

  const onTabChange = (key) => setActiveKey(key);

  const repImparArray = repData.estatistica_atraso_rep_impar || [];
  const repParArray = repData.estatistica_atraso_rep_par || [];
  const displayedRepData = currentRepPage === 1 ? repImparArray : repParArray;

  const atrasoImparArray = atrasoData.estatistica_atraso_impar || [];
  const atrasoParArray = atrasoData.estatistica_atraso_par || [];
  const displayedAtrasoData = currentAtrasoPage === 1 ? atrasoImparArray : atrasoParArray;

  const repColumns = [
    { title: 'Dezenas', dataIndex: 'repetido', key: 'repetido' },
    { title: 'Quantidade', dataIndex: 'qte', key: 'qte' },
    { title: '%', dataIndex: 'percente', key: 'percente', render: t => `${t} %` },
    { title: 'Média Sorteio', dataIndex: 'mdSorteio', key: 'mdSorteio' },
    {
      title: 'Atrasados',
      dataIndex: 'atrasados',
      key: 'atrasados',
      render: (t, r) => (
        <span className={r.atrasados > r.mdSorteio ? 'highlight-high' : ''}>{t}</span>
      )
    },
    {
      title: 'Status Jogos',
      dataIndex: 'pj',
      key: 'pj',
      render: t => {
        let cls = '';
        if (t === 'Melhor Opção!') {
          cls = 'melhor-opcao';
        } else if (t === 'Ruim' || t === 'Atrasados') {
         
        }
        return <span className={cls}>{t}</span>;
      }
    }
  ];

  const frequeColumns = [
    { title: 'Categoria', dataIndex: 'dezenas', key: 'dezenas' },
    { title: 'Quantidade', dataIndex: 'qte', key: 'qte' },
    { title: '%', dataIndex: 'percente', key: 'percente', render: t => `${t} %` },
    { title: 'Frequência', dataIndex: 'freqAcu', key: 'freqAcu', render: t => `${t} - JG` },
    { title: 'Frequência AC', dataIndex: 'freqAcmlda', key: 'freqAcmlda', render: t => `${t} %` },
  ];

  const atrasoColumns = [...repColumns].map(col =>
    col.dataIndex === 'repetido' ? { ...col, title: 'Números', dataIndex: 'dezenas', key: 'dezenas' } : col
  );

  const repChartData = displayedRepData.map(item => ({
    name: `${item.repetido} - Dz`,
    quantidade: item.qte,
    percentual: item.percente,
  }));

  const frequeChartData = frequeData.map(item => ({
    name: item.dezenas,
    quantidade: item.qte,
    percentual: item.percente,
    frequencia: item.freqAcu,
    frequenciaAc: item.freqAcmlda,
  }));

  const atrasoChartData = displayedAtrasoData.map(item => ({
    name: `Nu - ${item.dezenas}`,
    quantidade: item.qte,
    percentual: item.percente,
  }));

  const tabsItems = [
    {
      label: <LineChartOutlined className="icon-size-24" />,
      key: "1",
      children: (
        <div>
          <h2><span>Análise - Ímpar/Par</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart data={repChartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" /><YAxis /><Tooltip /><Legend />
              <Bar dataKey="quantidade" barSize={50} fill="#007AA2" />
              <Line type="monotone" dataKey="percentual" stroke="#ff7300" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table columns={repColumns} dataSource={displayedRepData} rowKey="id" pagination={false} />
          </div>
          <Pagination
            current={currentRepPage}
            total={2}
            pageSize={1}
            onChange={setCurrentRepPage}
            style={{ marginTop: 16, textAlign: 'center' }}
            itemRender={(page, type, originalElement) =>
              type === 'page' ? <a>{page === 1 ? 'Ímpar' : 'Par'}</a> : originalElement}
          />
        </div>
      )
    },
    {
      label: <BarChartOutlined className="icon-size-24" />,
      key: "2",
      children: (
        <div>
          <h2><span>Frequência - Ímpar/Par</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart data={frequeChartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" /><YAxis /><Tooltip /><Legend />
              <Bar dataKey="quantidade" stackId="a" barSize={50} fill="#004B57" />
              <Bar dataKey="percentual" stackId="a" barSize={50} fill="#ff7300" />
              <Bar dataKey="frequencia" stackId="a" barSize={50} fill="#007AA2" />
              <Bar dataKey="frequenciaAc" stackId="a" barSize={50} fill="#008DC0" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table columns={frequeColumns} dataSource={frequeData} rowKey="id" pagination={false} />
          </div>
        </div>
      )
    },
    {
      label: <AreaChartOutlined className="icon-size-24" />,
      key: "3",
      children: (
        <div>
          <h2><span>Dezenas - Ímpar/Par</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart data={atrasoChartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" /><YAxis /><Tooltip /><Legend />
              <Bar dataKey="quantidade" barSize={50} fill="#007AA2" />
              <Line type="monotone" dataKey="percentual" stroke="#ff7300" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table columns={atrasoColumns} dataSource={displayedAtrasoData} rowKey="id" pagination={false} />
          </div>
          <Pagination
            current={currentAtrasoPage}
            total={2}
            pageSize={1}
            onChange={setCurrentAtrasoPage}
            style={{ marginTop: 16, textAlign: 'center' }}
            itemRender={(page, type, originalElement) =>
              type === 'page' ? <a>{page === 1 ? 'Ímpar' : 'Par'}</a> : originalElement}
          />
        </div>
      )
    },
    {
      label: <BulbOutlined className="icon-size-24" />,
      key: "4",
      children: <h2><span>Ideias Dz - Ímpar/Par</span></h2>
    },
    {
      label: <MenuOutlined className="icon-size-24" onClick={() => navigate("/dashboard")} />,
      key: "5"
    }
  ];

  return (
    <div className="analysis-container">
      <Tabs activeKey={activeKey} onChange={onTabChange} tabPosition="right" items={tabsItems} />
    </div>
  );
};

export default AnaliseParImparCC;
